import React from 'react';

const AuthzPermissionGroupFormModal = React.lazy(() => import('../components/FormModal'));
const authzPermissionGroupModalRegistry = {
    core_authzPermissionGroupId: AuthzPermissionGroupFormModal
};
export default authzPermissionGroupModalRegistry;
